import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onReset }) => {
  return (
    <div className="card text-center py-12 md:py-16">
      <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-muted mx-auto mb-6 flex items-center justify-center">
        <Icon name="Search" size={40} color="var(--color-muted-foreground)" />
      </div>
      
      <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-3">
        No Members Found
      </h3>
      
      <p className="text-sm md:text-base text-muted-foreground mb-6 max-w-md mx-auto">
        We couldn't find any members matching your search criteria. Try adjusting your filters or search terms.
      </p>
      
      <Button
        variant="outline"
        onClick={onReset}
        iconName="RotateCcw"
        iconPosition="left"
      >
        Reset Filters
      </Button>
    </div>
  );
};

export default EmptyState;